export const SAVING_PERCENT_FOR_YEARLY_INCOME = 'savingPercentForYearlyIncome';
export const MY_YEARLY_INCOME = 'myYearlyIncome';



// WEBPACK FOOTER //
// ./src/app/shared/slider/single-slider/constants.ts